import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import 'hammerjs'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent   {
  title = 'ehmulation';

  constructor(private renderer: Renderer2){}

  ngOnInit()
  {
    // this.loadScript()
  }

  // ngAfterViewInit() {
  //   let loader = this.renderer.selectRootElement('#loader');
  //   this.renderer.setStyle(loader, 'display', 'none');
  // }

    public loadScript() {
      let body = <HTMLDivElement> document.body;
      let script = document.createElement('script');
      script.innerHTML = '';
      script.src = 'assets/js/function.js';
      script.async = true;
      script.defer = true;
      body.appendChild(script);
  }
}
